<template>
  <div class="main-login">
    <div class="login-container">
      <div class="theme-toggle" @click="toggleTheme" v-show="!showInstallPrompt || isStandalone">
        <img src="../assets/images/toggle-dark-mode.svg" alt="Toggle Theme">
      </div>
      <div id="video">
        <video autoplay loop muted playsinline width="100%"><source src="@/assets/jaffel_backdrop.mp4" type="video/mp4"></video>
      </div>
      <img v-if="currentTheme === 'dark'" alt="Clink Logo" src="../assets/images/clink-wide-text-white.png">
      <img v-else alt="Clink Logo" src="../assets/images/clink-wide-text.png">
      <p v-if="msg">{{msg}}</p>
      <div class="login-form" v-if="loginMode && !forgotMode">
        <form v-on:submit.prevent="submit">
          <table class="login-fields">
            <tbody>
              <tr>
                <td><label for="email">E-Mail</label></td>
                <td><input type="text" id="email" v-model="credentials.email"></td>
              </tr>
              <tr>
                <td><label for="password">Passwort</label></td>
                <td><input type="password" id="password" v-model="credentials.password"></td>
              </tr>
            </tbody>
          </table>
          <div class="forgot-link-container">
            <a href="#" class="forgot-link" @click.prevent="forgotMode = true">Passwort vergessen?</a>
          </div>
          <div class="buttons">
            <button type="submit" class="login">Login</button>
            <button class="to-register" @click="loginMode = false;">Registrieren</button>
          </div>
        </form>
      </div>

      <div class="forgot-form" v-if="forgotMode">
        <form v-on:submit.prevent="requestReset">
          <table class="login-fields">
            <tbody>
              <tr>
                <td><label for="reset-email">E-Mail für Wiederherstellung</label></td>
                <td><input type="text" id="reset-email" v-model="resetEmail"></td>
              </tr>
            </tbody>
          </table>
          <div class="buttons">
            <button type="submit" class="login" :class="{disabled_loading: submittingReset}">Link senden</button>
            <button class="to-register" @click="forgotMode = false">Zurück zum Login</button>
          </div>
        </form>
      </div>

      <div class="register-form" v-if="!loginMode && !forgotMode">
        <form v-on:submit.prevent="submit">
          <table class="login-fields">
            <tbody>
              <tr>
                <td><label for="email">E-Mail</label></td>
                <td><input type="text" id="email" v-model="credentials.email"></td>
              </tr>
              <tr>
                <td><label for="password">Passwort</label></td>
                <td><input type="password" id="password" v-model="credentials.password"></td>
              </tr>
              <tr>
                <td><label for="password">Wiederholen</label></td>
                <td><input type="password" id="password" v-model="credentials.password_repeat"></td>
              </tr>
              <tr class="privacy-policy-row">
                <td class="checkbox-container">
                  <input type="checkbox" id="legal-consent" v-model="legalAccepted">
                  <label for="legal-consent">
                    Ich akzeptiere die <router-link to="/terms-of-service">AGB</router-link> und <router-link to="/privacy-policy">Datenschutzerklärung</router-link> und bestätige, dass ich durch die sofortige Freischaltung digitaler Inhalte mein <router-link to="/withdrawal">Widerrufsrecht</router-link> verliere.
                  </label>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="buttons">
            <button type="submit" class="login">Registrieren</button>
            <button class="to-register" @click="loginMode = true;">Zurück zum Login</button>
          </div>
        </form>
      </div>

      <!-- PWA Install Prompt -->
      <div v-if="showInstallPrompt && !isStandalone" class="install-prompt-container frosted">
        <img v-if="currentTheme === 'dark'" alt="Clink Logo" src="../assets/images/clink-wide-text-white.png">
        <img v-else alt="Clink Logo" src="../assets/images/clink-wide-text.png">
        <div class="install-content">
          <h3>Clink als App installieren</h3>
          <p v-if="platform === 'android'">Installiere Clink für den schnellen Zugriff direkt auf deinem Homescreen.</p>
          <p v-if="platform === 'ios'">Tippe auf das <b>Teilen-Symbol</b> (Quadrat mit Pfeil) und dann auf <b>"Zum Home-Bildschirm"</b>, um Clink als App zu nutzen.</p>
          <div class="install-buttons">
            <button v-if="platform === 'android'" @click="installPWA" class="install-btn">Jetzt installieren</button>
            <button @click="showInstallPrompt = false" class="later-btn">Später</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthService from '@/services/AuthService.js';

export default {
  name: 'LoginView',
  data() {
    return {
      loginMode: true,
      credentials: {
        email: null,
        password_repeat: null,
        password: null,
      },
      msg: null,
      forgotMode: false,
      resetEmail: null,
      submittingReset: false,
      legalAccepted: false,
      showInstallPrompt: false,
      deferredPrompt: null,
      platform: 'other',
      isStandalone: false,
      currentTheme: 'light',
    };
  },
  mounted() {
    this.detectPWA();
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      this.deferredPrompt = e;
      this.showInstallPrompt = true;
      this.platform = 'android';
    });
    
    // Check if it's iOS
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (isIOS && !this.isStandalone) {
      this.platform = 'ios';
      this.showInstallPrompt = true;
    }
    
    this.currentTheme = localStorage.getItem('theme') || 'light';
  },
  components: {
  },
  async created() {
    if (!this.$store.getters.isLoggedIn) {
      console.error("not logged in!")
    } else {
      this.$router.push('/');
    }

    this.username = this.$store.getters.getUser.username;
  },
  methods: {
    async submit(){
      this.msg = null;

      if(!this.validateCredentials()){
        return -1
      }

      if(this.loginMode) {
        try{
          let result = await AuthService.login(this.credentials);
          if(result.success){
            this.msg = "Login erfolgreich!"
            const token = result.token;
            const user = result.user;

            this.$store.dispatch('login', { token, user });
            
            // Check for pending invite
            const pendingCode = localStorage.getItem('pending_invite_code');
            if (pendingCode) {
              this.$router.push('/pool-settings?join_code=' + pendingCode);
            } else {
              this.$router.push('/');
            }
          }
        } catch(e){
          console.error(e)
          this.msg = e.response.data.msg
        }
      } else { //if we are not logging in, we are registering
        if(this.credentials.password !== this.credentials.password_repeat){
          this.msg = "Die Passwörter stimmen nicht überein!"
        } else if (!this.legalAccepted) {
          this.msg = "Bitte akzeptiere zuerst die Bestimmungen!"
        } else {
          try{
            let result = await AuthService.signUp(this.credentials);
            console.log(result)
            if(result.success){
              this.msg = "Registrierung erfolgreich!"
              this.loginMode = true;
            }
          } catch(e){
            console.error(e)
            this.msg = e.response.data.msg
          }
        }
      }
    },
    validateCredentials(){
      if(!this.validateEmail(this.credentials.email)){
        this.msg = "Bitte gib eine gültige E-Mail Adresse an!"
        return -1
      }

      if(!this.credentials.password){
        this.msg = "Bitte gib ein Passwort ein!"
        return -1
      }

      if(!this.loginMode && (this.credentials.password !== this.credentials.password_repeat)){
        this.msg = "Passwörter stimmen nicht überein!"
        return -1
      }

      return true
    },
    validateEmail(email){
      return String(email)
          .toLowerCase()
          .match(
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
    },
    detectPWA() {
      this.isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
    },
    async installPWA() {
      if (!this.deferredPrompt) return;
      this.deferredPrompt.prompt();
      const { outcome } = await this.deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        this.showInstallPrompt = false;
      }
      this.deferredPrompt = null;
    },
    async requestReset() {
      if (this.submittingReset) return;
      this.msg = null;

      if (!this.validateEmail(this.resetEmail)) {
        this.msg = "Bitte gib eine gültige E-Mail Adresse an!";
        return;
      }

      this.submittingReset = true;
      try {
        const result = await AuthService.requestPasswordReset({ email: this.resetEmail });
        this.msg = result.msg;
        if (result.msg?.includes("verschickt")) {
            this.forgotMode = false;
        }
      } catch (e) {
        this.msg = e.response?.data?.msg || "Ein Fehler ist aufgetreten.";
      } finally {
        this.submittingReset = false;
      }
    },
    toggleTheme() {
      this.currentTheme = this.currentTheme === 'light' ? 'dark' : 'light';
      localStorage.setItem('theme', this.currentTheme);
      document.documentElement.setAttribute('data-theme', this.currentTheme);
    }
  }
}
</script>
<style scoped>
.main-login {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: var(--background);
  overflow: hidden;
}

#video:before {
  content:"";
  position: absolute;
  top:0;
  right:0;
  left:0;
  bottom:0;
  z-index:1;
  background: var(--lighten-bg);
}

#video {
  left: 0%;
  top: 0%;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  position: absolute;
  z-index: -1;
  filter: blur(8px);
  display: flex;
}

#video video {
  object-fit: cover;
}

img {
  width: 300px;
  border-radius: var(--radius-l);
  margin-bottom: 20px;
  background: transparent;
}

h1 {
  font-size: 1.5rem;
  margin-bottom: 30px;
  max-width: 80%;
  text-align: center;
}

p {
  color: var(--tertiary-color);
  margin-bottom: 20px;
}

.login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 400px;
  width: 90%;
  background: transparent;
  /* padding: 20px; removed padding to simplify mobile view */
}

.login-form, .register-form, .forgot-form {
  width: 100%;
}


.login-fields {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 15px;
}

.login-fields td {
  display: block;
  width: 100%;
}

label {
  display: block;
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--secondary-color);
  margin-bottom: 5px;
  text-align: left;
}

input {
  font-size: 1.1rem;
  padding: 15px;
  border: none;
  border-radius: var(--radius-m);
  background-color: var(--background-secondary);
  color: var(--primary-color);
  width: 100%;
  box-sizing: border-box;
}

input:focus {
  outline: 2px solid var(--primary-color);
}

.forgot-link-container {
  text-align: right;
  margin-top: -5px;
  width: 100%;
}

.forgot-link {
  font-size: 0.85rem;
  color: var(--tertiary-color);
  text-decoration: none;
}

.forgot-link:hover {
  text-decoration: underline;
}

.privacy-policy-row label {
  display: inline;
  font-size: 0.85rem;
  margin-bottom: 0;
  vertical-align: middle;
}

.privacy-policy-row .checkbox-container {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}

.privacy-policy-row input[type="checkbox"] {
  width: 20px;
  height: 20px;
  margin: 0;
  flex-shrink: 0;
}

.privacy-policy-row a {
  color: var(--primary-color);
  font-weight: 600;
  text-decoration: none;
}

.buttons {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
}

button.login {
  font-family: var(--font);
  color: var(--text-on-primary);
  border: none;
  font-size: 1.1rem;
  font-weight: 600;
  background: var(--primary-color);
  border-radius: var(--radius-l);
  padding: 18px;
  cursor: pointer;
  transition: opacity 0.2s;
}

button.login:active {
  opacity: 0.8;
}

button.to-register {
  background: none;
  border: none;
  font-size: 1rem;
  color: var(--primary-color);
  cursor: pointer;
  padding: 10px;
}

/* PWA Prompt Styles */
.install-prompt-container {
  margin: 20px 0;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  text-align: left;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.install-content h3 {
  margin: 0 0 10px 0;
  font-size: 1.1rem;
}

.install-content p {
  font-size: 0.9rem;
  margin-bottom: 15px;
  line-height: 1.4;
  color: var(--secondary-color);
}

.install-buttons {
  display: flex;
  gap: 10px;
}

.install-btn {
  background: var(--primary-color);
  color: var(--text-on-primary);
  padding: 8px 16px;
  border-radius: var(--radius-s);
  font-weight: 600;
  font-size: 0.9rem !important;
}

.later-btn {
  background: var(--background);
  border-radius: var(--radius-s);
  border: 1px solid var(--tertiary-color);
  color: var(--primary-color);
  font-size: 1rem;
  padding: 8px;
}

.theme-toggle {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--glass-bg);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid var(--border-color);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
}

.theme-toggle img {
  width: 24px;
  height: 24px;
  margin-bottom: 0;
  border-radius: 0;
  filter: var(--icon-filter);
}

.theme-toggle:active {
  transform: scale(0.95);
}
</style>
